import { Injectable } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ConfirmModalComponent } from "@shared/confirm-modal/confirm-modal.component";
import { IConfirmationDialogModalOpen } from "../interfaces/default.interface";

@Injectable({
  providedIn: "root",
})
export class ConfirmationDialogService {
  constructor(private modalService: NgbModal) {}

  open(options: IConfirmationDialogModalOpen): Promise<boolean> {
    const {
      title = "",
      message = "",
      confirmText = "BUTTON.DELETE",
      cancelText = "CONFIRMATION.CANCEL",
      btnStyleType = "danger",
      warningMessage = "",
      hasFooter = true,
    } = options;
    const modalRef = this.modalService.open(ConfirmModalComponent, {
      centered: true,
    });
    modalRef.componentInstance.modalTitle = title;
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.confirmText = confirmText;
    modalRef.componentInstance.cancelText = cancelText;
    modalRef.componentInstance.btnStyleType = btnStyleType;
    modalRef.componentInstance.warningMessage = warningMessage;
    modalRef.componentInstance.hasFooter = hasFooter;

    return modalRef.result;
  }
}
